"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartGroupNewType = void 0;
var ChartGroupNewType;
(function (ChartGroupNewType) {
    ChartGroupNewType[ChartGroupNewType["NONE"] = 0] = "NONE";
    ChartGroupNewType[ChartGroupNewType["PRICEPERSQUAREFOOT"] = 1] = "PRICEPERSQUAREFOOT";
    ChartGroupNewType[ChartGroupNewType["TRANSACTIONAMOUNT"] = 2] = "TRANSACTIONAMOUNT";
    ChartGroupNewType[ChartGroupNewType["TURNOVERRATE"] = 3] = "TURNOVERRATE";
    ChartGroupNewType[ChartGroupNewType["PRICERANGE"] = 4] = "PRICERANGE";
    ChartGroupNewType[ChartGroupNewType["TRANSACTIONBYPRICERANGE"] = 5] = "TRANSACTIONBYPRICERANGE";
})(ChartGroupNewType = exports.ChartGroupNewType || (exports.ChartGroupNewType = {}));
